"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _validator = require("@aperza/validator");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createFieldMap = function createFieldMap(config) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var fieldMap = {};
  Object.keys(config).forEach(function (key) {
    var configEntry = config[key];
    var value = data && data[key] ? data[key] : configEntry.value ? configEntry.value : '';

    if (data && !(key in data) && configEntry.value) {
      data[key] = configEntry.value;
    }

    fieldMap[key] = _objectSpread({}, configEntry, {
      value: value,
      errorId: '',
      constraint: configEntry.constraint,
      options: configEntry.options
    });
  });
  return fieldMap;
};

var updateFieldMapData = function updateFieldMapData(fieldMap, data) {
  var clonedFieldMap = Object.assign({}, fieldMap);

  if (clonedFieldMap && data) {
    Object.keys(clonedFieldMap).map(function (key) {
      clonedFieldMap[key].value = data[key] === undefined ? '' : data[key];
    });
  }

  return clonedFieldMap;
};

var clearFieldMapError = function clearFieldMapError(fieldMap) {
  var clonedFieldMap = Object.assign({}, fieldMap);

  if (clonedFieldMap) {
    Object.keys(clonedFieldMap).map(function (key) {
      clonedFieldMap[key].errorId = '';
      clonedFieldMap[key].invalid = false;
    });
  }

  return clonedFieldMap;
};

var updateFieldMapValue = function updateFieldMapValue(fieldMap, field, value) {
  var clonedFieldMap = Object.assign({}, fieldMap);
  var shouldUpdate = clonedFieldMap[field].floatOnly && !isNaN(parseFloat(value)) && /^-?\d*\.?\d*$/.test(value) || clonedFieldMap[field].intOnly && !isNaN(parseInt(value)) && /^-?\d*$/.test(value) || !clonedFieldMap[field].floatOnly && !clonedFieldMap[field].intOnly && clonedFieldMap[field].value !== value || value === '';

  if (shouldUpdate) {
    clonedFieldMap[field].value = value;
  }

  return clonedFieldMap;
};

var updateFieldMapConstraint = function updateFieldMapConstraint(fieldMap, field, constraint) {
  var clonedFieldMap = Object.assign({}, fieldMap);
  clonedFieldMap[field].constraint = constraint;
  return clonedFieldMap;
};
/**
 * A hook to manage the fields of a form.
 * A config is an object to hold the configuration of each field.
 * Example of a config entry.
 * first_name: {
      fieldName: 'first_name',
      constraint: Constraint.firstName,
      value: user.firstName ? user.firstName : '',
   },
 *
 * fieldName: property name of the field
 * constraint: field validation rules using validate.js refer to @aperza/validation project
 * value: initial value. Must not be undefined otherwise the Controlled React Component will become Uncontrolled Component.
 * errorId: Error message from validator
 * invalid: a flag to indicate whether there is a validation error in each field.
 *
 * @param config
 * @param initialData
 */


var useFieldMap = function useFieldMap(_config, _initialData) {
  var _useState = (0, _react.useState)(_config),
      _useState2 = _slicedToArray(_useState, 2),
      config = _useState2[0],
      setConfig = _useState2[1];

  var _useState3 = (0, _react.useState)(_initialData),
      _useState4 = _slicedToArray(_useState3, 2),
      initialData = _useState4[0],
      setInitialData = _useState4[1];

  var _useState5 = (0, _react.useState)(createFieldMap(_config, _initialData)),
      _useState6 = _slicedToArray(_useState5, 2),
      fieldMap = _useState6[0],
      setFieldMap = _useState6[1];

  var updateFieldMapConfig = function updateFieldMapConfig(_config, _initialData) {
    setConfig(_config);
    setInitialData(_initialData);
    setFieldMap(createFieldMap(_config, _initialData));
  };

  var updateFieldMap = function updateFieldMap() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setFieldMap(updateFieldMapData(fieldMap, data));
  };

  var resetFieldMap = function resetFieldMap() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialData;
    updateFieldMap(data);
    setFieldMap(clearFieldMapError(fieldMap));
  };

  var updateFieldValue = function updateFieldValue(field) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

    if (field) {
      setFieldMap(updateFieldMapValue(fieldMap, field, value));
    }
  };

  var updateFieldConstraint = function updateFieldConstraint(field, constraint) {
    if (field) {
      setFieldMap(updateFieldMapConstraint(fieldMap, field, constraint));
    }
  };

  var validateFieldMap = function validateFieldMap(returnErrorCount) {
    var validatedFieldMap = _validator.ValidatorUtil.validateForm(fieldMap);

    setFieldMap(validatedFieldMap);
    if (returnErrorCount) return _validator.ValidatorUtil.countError(validatedFieldMap);
    return validatedFieldMap;
  };

  var validateField = function validateField(field) {
    var validatedFieldMap = _validator.ValidatorUtil.validateFormField(fieldMap, field);

    setFieldMap(validatedFieldMap);
    return _validator.ValidatorUtil.countError(validatedFieldMap);
  };

  var getFieldMapValue = function getFieldMapValue() {
    var clonedFieldMap = Object.assign({}, fieldMap);
    var value = {};

    if (clonedFieldMap) {
      Object.keys(clonedFieldMap).map(function (key) {
        value[key] = clonedFieldMap[key].value;
      });
    }

    return value;
  };

  var getFieldValue = function getFieldValue(field) {
    var clonedFieldMap = Object.assign({}, fieldMap);

    if (clonedFieldMap) {
      return clonedFieldMap[field].value;
    }

    return '';
  };

  return {
    fieldMap: fieldMap,
    setFieldMap: setFieldMap,
    updateFieldMapConfig: updateFieldMapConfig,
    updateFieldMap: updateFieldMap,
    resetFieldMap: resetFieldMap,
    updateFieldValue: updateFieldValue,
    updateFieldConstraint: updateFieldConstraint,
    validateFieldMap: validateFieldMap,
    validateField: validateField,
    getFieldMapValue: getFieldMapValue,
    getFieldValue: getFieldValue
  };
};

var _default = useFieldMap;
exports.default = _default;